export default {
  catalogues: state => state.lookbook.lookbooks,
  ambiences: state => state.lookbook.items,
  attributes: state => state.lookbook.attributes,
  loadingAmbiences: state => state.loading,
  current: state => state.current
};